import React, { useState, useEffect } from "react";
import Papa from "papaparse";

function CsvTable({ csvUrl }) {
  const [csvData, setCsvData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [loading, setLoading] = useState(true);

  //   const csvUrl = "https://kg-dev01.s3.us-west-1.amazonaws.com/process2-results/Fribourg-data.csv"; // Replace with your S3 CSV file URL

  // Fetch CSV data from the S3 URL
  useEffect(() => {
    fetch(csvUrl)
      .then((response) => response.text()) // Read response as text
      .then((data) => {
        // Parse the CSV data
        Papa.parse(data, {
          complete: (result) => {
            setHeaders(result.data[0]); // First row as headers
            setCsvData(result.data.slice(1)); // Remaining rows as data
          },
          header: false, // Manually handle headers
          skipEmptyLines: true, // Skip empty lines
        });
      })
      .catch((error) => {
        console.error("Error fetching the CSV file:", error);
        setLoading(false);
        setCsvData([])
        setHeaders([])
      }).finally(() => {
        setLoading(false);
      });
  }, [csvUrl]); // Run once when the component mounts

  if (loading) {
    return <div>Loading CSV data...</div>;
  }

  return (
    // <div className="container mx-auto p-5">
    <div className="p-2">
      {csvData.length > 0 && (
        <table className="min-w-full table-auto border-collapse border border-gray-300">
          <thead>
            <tr className="bg-blue-600 text-white">
              {headers.map((header, index) => (
                <th
                  key={index}
                  className="px-4 py-2 border border-gray-300 text-left font-medium text-sm"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {csvData.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                className={`${rowIndex % 2 === 0 ? "bg-gray-50" : "bg-white"
                  } hover:bg-gray-100`}
              >
                {row.map((cell, cellIndex) => (
                  <td
                    key={cellIndex}
                    className="px-4 py-2 border border-gray-300 text-sm text-gray-700"
                  >
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default CsvTable;
